import { lazy, Suspense } from 'react';

import { AppTypes } from '@/app-config/appTypes.ts';
import { getAppType } from '@/app-config/featureConfig.ts';

const BAEApp = lazy(() => import('@/app/bae'));
const DigitalTwinApp = lazy(() => import('src/app/digital-twin'));
const NewFrontApp = lazy(() => import('@/app/new-front'));

const App = () => {
    // Initialize the app type based on the environment or the stored value
    const appType = getAppType();

    function isDigitalTwin() {
        return appType === AppTypes.GLOBAL_FABRIC || appType === AppTypes.MIST;
    }

    if (appType === AppTypes.NEW_FRONT) {
        return (
            <Suspense fallback={null}>
                <NewFrontApp />
            </Suspense>
        );
    }

    if (isDigitalTwin()) {
        return (
            <Suspense fallback={null}>
                <DigitalTwinApp />
            </Suspense>
        );
    }

    return (
        <Suspense fallback={null}>
            <BAEApp />
        </Suspense>
    );
};

export default App;
